const input = (theme) => {
  const borderColor = `rgba(${theme.palette.customColors.main}, 0.22)`;
  const borderHover = `rgba(${theme.palette.customColors.main}, 0.4)`;
  const focusBorder = theme.palette.primary.main;

  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
          fontSize: "0.875rem",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: 1.5,
          marginBottom: 6,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: 1.4,
          margin: "6px 0 0",
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
          fontSize: "0.875rem",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          "&:before": {
            borderBottom: `1px solid ${borderColor}`,
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: `1px solid ${borderHover}`,
          },
          "&.Mui-disabled:before": {
            borderBottomStyle: "solid",
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: theme.palette.grey[50],
          fontSize: "0.875rem",
          "&:hover:not(.Mui-disabled)": {
            backgroundColor: theme.palette.grey[100],
          },
          "&:before": {
            borderBottom: `1px solid ${borderColor}`,
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: `1px solid ${borderHover}`,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontSize: "0.875rem",
          minHeight: 40,
          "&:hover:not(.Mui-focused):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            borderColor: borderHover,
          },
          "&:hover.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.error.main,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: borderColor,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: focusBorder,
            borderWidth: 2,
          },
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.action.disabledBackground,
          },
        },
        input: {
          padding: "10px 12px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
  };
};

export default input;
